// Other filter options
export const OTHER_FILTERS = {
  ACCESSIBLE: "Accessible",
  CHILD_FRIENDLY: "Child Friendly",
  ALCOHOL_ALLOWED: "Alcohol is Allowed"
}

export const OTHER_OPTIONS = [
  OTHER_FILTERS.ACCESSIBLE,
  OTHER_FILTERS.CHILD_FRIENDLY,
  OTHER_FILTERS.ALCOHOL_ALLOWED
]
export const LANGUAGES = [
  "English",
  "Spanish"
]
export const SKILL_LEVELS = [
  "Beginner",
  "Intermediate",
  "Advanced",
  "Professional"
]
